import { GAME_ADMIN_RESOURCES, GAME_ADMIN_SCOPES, PAGE_NAMES } from 'constant';
import usePermission from 'commons-ui/src/permission/usePermission';

export const makeActionList = () => {
	const { hasPermission } = usePermission();
	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						configPageName: PAGE_NAMES.gameAdmin,
						configResourceName: GAME_ADMIN_RESOURCES.zkDashBoardUpdate,
						configActionName: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkDashBoardUpdate].updateZkKeyPartially
					});
				}
			},
			{
				name: 'PromoteOnProd',
				id: 'promoteOnProd',
				isEnabled: () => {
					return hasPermission({
						configPageName: PAGE_NAMES.gameAdmin,
						configResourceName: GAME_ADMIN_RESOURCES.zkDashBoardUpdate,
						configActionName: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkDashBoardUpdate].promoteToProdDirectly
					});
				}
			}
		],
		addAction: []
	};
};

export default {
	makeActionList
};
